// removed by extract-text-webpack-plugin
module.exports = {"Black":"#333D47","recipeList":"G65f560","recipeListText":"G59a6d9","item":"Gea9a90"};